import * as ReactDOM from "react-dom";
import * as React from "react";
import styled, { css } from "styled-components";
const closeIcon = "https://i.ezbuy.sg/FjI8PeAeO6ln_xpIO1X-nim5Dn9t";
const Wrapper = styled.div `
	position: fixed;
	overflow: auto;
	display: table;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;
	background-color: rgba(0, 0, 0, 0.4);
	opacity: 0;
	transition: all 350ms;
	visibility: hidden;

	${(props) => props.show &&
    css `
			visibility: visible;
			opacity: 1;
			transition-delay: 0s;
		`}
`;
const Cell = styled.div `
	display: table-cell;
	vertical-align: middle;
`;
const Container = styled.div `
	box-sizing: border-box;
	background-color: #fff;
	margin: 0 auto;
	border-radius: 2px;
	padding: 24px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	transform: scale(1.1);
	display: flex;
	flex-direction: column;

	${(props) => props.show &&
    css `
			transform: scale(1);
		`}
	.closeBTN {
		position: absolute;
		right: 12px;
		top: 12px;
		display: block;
		width: 18px;
		height: 18px;
		cursor: pointer;
	}
	.content {
		flex: 1;
	}
`;
const OkBtn = styled.a `
	display: block;
	text-align: center;
	height: 36px;
	font-size: 16px;
	font-weight: 500;
	line-height: 36px;
	text-decoration: none;
	cursor: pointer;
	background: linear-gradient(133deg, #ff7200 0%, #ff5a00 100%);
	color: #fff;
	margin-top: 30px;
	&:hover {
		color: #fff;
	}
`;
export class Modal extends React.Component {
    static info(config) {
        if (typeof config === "string") {
            modal({ content: config });
        }
        else {
            modal(config);
        }
    }
    render() {
        const { children, footer, style, okText, onOk, onCancel, visible, width } = this.props;
        return (React.createElement(Wrapper, { show: visible },
            React.createElement(Cell, null,
                React.createElement(Container, { show: visible, style: Object.assign(Object.assign({}, style), { width }) },
                    React.createElement("img", { src: closeIcon, className: "closeBTN", onClick: onCancel, alt: "" }),
                    React.createElement("div", { className: "content" }, children),
                    footer === undefined ? React.createElement(OkBtn, { onClick: onOk }, okText) : footer))));
    }
}
Modal.defaultProps = {
    visible: false,
    showClose: true,
    okText: "Confirm",
    width: 660,
};
function modal(config) {
    const div = document.createElement("div");
    document.body.appendChild(div);
    function close() {
        ReactDOM.unmountComponentAtNode(div);
        div.parentNode.removeChild(div);
    }
    function onCancel() {
        const { onCancel } = config;
        if (typeof onCancel === "function") {
            onCancel();
        }
        close();
    }
    function onOK() {
        const { onOK } = config;
        if (typeof onOK === "function") {
            onOK();
        }
        close();
    }
    const { footer, content, okText, width, style } = config;
    ReactDOM.render(React.createElement(Modal, { visible: true, style: style, width: width || 420, okText: okText || "Confirm", footer: footer, onCancel: onCancel, onOk: onOK }, content), div);
}
export default Modal;
